import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';
import { BgImage } from 'gbimage-bridge';
import Logo from '../../assets/PillarFinal--white.svg';

export default function Hero() {
  
  const data = useStaticQuery(graphql`
    {
      file(relativePath: {eq: "shutterstock_206350801.jpg"}) {
        id
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
          )
        }
      }
    }
  `)

  const heroBG = getImage(data.file);
  const stackedHeroBG = [`linear-gradient(rgba(47,47,47,0.7),rgba(47,47,47,0.7))`, heroBG];

  return (
    <div className="hero">
      <div className="hero--slide">
        <BgImage className="hero--slide__inner" image={stackedHeroBG} loading="eager" preserveStackingContext />
      </div>
      <div className="hero--caption">
        <div className="hero--caption__content">
          <h2>When Results Matter</h2>
          <div className="h-line"></div>
          <h1 className="hidden">Dreyer Law Firm, PLLC</h1>
          <Logo />
          <p>With aggressive, dedicated, and experienced personal injury lawyers on hand, our practice is your solution.</p>
          <Link to="/contact-us" className="hero-btn">Contact Us Now</Link>
        </div>
      </div>
    </div>
  );
}
